const routes = [
    {
        path: "/staff",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "staff_index"
        }
    }
];

export default routes;
